'use strict';

import $ from 'jquery';

/**
 * This module sets up the image carousel on the auction page
 */
const carousel = {


  /**
   * Fires after slide change
   *
   * @param {object} evt             Slick carousel event
   * @param {object} slick           Slick carousel element
   * @param {number} currentSlide    Slick carousel's current slide index.
   */
  afterChange: function( evt, slick, currentSlide ) {

    this.updateCurrentSlideToUI(currentSlide)
    this.checkSlickNoSlide();
  },

  /**
   * Updates current slide to UI.
   *
   * @param {number} currentSlide   Index of current slide in carousel. If undefined defaults it is set to 1.
   */
  updateCurrentSlideToUI: function( currentSlide ) {

    $('.counter .current').html( currentSlide ? currentSlide + 1 : 1 );
  },

  /**
   * This function fixes problems when carousel has too few items
   * Copied from here: https://github.com/kenwheeler/slick/issues/262#issuecomment-187640240
   */
  checkSlickNoSlide: function() {

    const elm = $('.image-carousel-nav');
    if (elm.length === 0) {
      return;
    }

    const getSlick = elm.slick('getSlick');

    if(getSlick.slideCount <= getSlick.options.slidesToShow) {
      elm.addClass('slick-no-slide');
    }
    else {
      elm.removeClass('slick-no-slide');
    }
  },

  init: function() {
    $('.image-carousel').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      asNavFor: '.image-carousel-nav',
      prevArrow: '.slick-arrow-carousel.slick-prev',
      nextArrow: '.slick-arrow-carousel.slick-next'
    });

    $('.image-carousel-nav').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.image-carousel',
      centerMode: true,
      focusOnSelect: true,
      centerPadding: '-50%',
      prevArrow: '.slick-arrow-nav.slick-prev',
      nextArrow: '.slick-arrow-nav.slick-next',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 3
          }
        }
      ]
    });

    this.updateCurrentSlideToUI();
    this.checkSlickNoSlide();

    $('.image-carousel-nav').on( 'afterChange', this.afterChange.bind( this ) );
  }
};

module.exports = carousel;
